/* eslint-disable */
import { useState, useEffect, useMemo } from "react";
import { exportService } from "../dependencyInjection";
import { unsubscribe } from "../../../../utils";
import { ExportType } from "../services/ExportService";

type UseGetExportResult = (reportDefinition: any, exportType: ExportType) => Promise<boolean>;
type UseGetExportUsersResult = (exportType: ExportType) => Promise<boolean>;
type UseExportResult = [boolean, UseGetExportResult, UseGetExportUsersResult];

export function useExport(): UseExportResult {
  const [pendind, setPending] = useState(false);
  useEffect(() => {
    const subLoading = exportService.loading$.subscribe((loading) => {
      setPending(loading);
    });
    return unsubscribe(subLoading);
  }, []);

  const getExportResult = useMemo(
    () => async (reportDefinition: any, exportType: ExportType) => {
      try {
        return await exportService.getExportResult(reportDefinition, exportType);
      } catch (e) {
        return false;
      }
    },
    [],
  );

  const getExportUsersResult = useMemo(
    () => async (exportType: ExportType) => {
      try {
        return await exportService.getExportUsersResult(exportType);
      } catch (e) {
        return false;
      }
    },
    [],
  );

  return [pendind, getExportResult, getExportUsersResult];
}
